<template>
  <div
    v-if="order.customer_total_credit > 0"
    class="open credit-amount-checkbox"
  >
    <div class="credits-checkbox-and-label">
      <input
        v-model="creditUsed"
        type="checkbox"
        checked="on"
        class="credit-checkbox"
        @change="updateCreditApplied()"
      >
      <span><b>{{ $t(&quot;cart.applyCredit&quot;) }}: </b>{{ customerTotalDecorated }}</span>
    </div>
  </div>
</template>

<script>
import CartApi from './cart_api'
import { mapMutations } from 'vuex'
export default {

  props: {
    order: {
      default: null,
      required: false,
      type: Object
    }
  },
  computed: {
    negativeAmount(){
      return this.order.credit_amount_decorated
    },
    customerTotalDecorated(){
      return this.order.customer_total_credit_decorated
    },
    creditUsed: {
      get() {
        if(this.$store){
          return this.$store.state.checkout.applyCredit
        }

        return false
      },
      set() {
        this.toggleCreditApplication()
      }
    }
  },

  mounted(){
    this.setInitialCredit()
  },


  methods: {
    ...mapMutations('checkout', ['setOriginalCredit', 'updateCreditAmount', 'updateOrderTotal', 'toggleCreditApplication']),
    setInitialCredit(){
      if(this.$store){

        this.applyInitialCredit()
        this.setOriginalCredit(this.order.credit_amount)
        this.updateOrderTotal(this.order.total)
        if( 0 < this.order.credit_amount - this.order.total && this.order.credit_amount - this.order.total <= 100){
          this.updateCreditAmount(this.order.total)
        } else {
          this.updateCreditAmount(this.order.credit_amount)
        }
      }
    },
    applyInitialCredit(){
      if( this.order.customer_total_credit > 0 && this.order.credit_amount == 0 ){
        let body = JSON.stringify(
          { order: { apply_credit: true } }
        )
        CartApi.changeOrder(body)
      }
    },
    updateCreditApplied(){
      if(this.$store){
        let checkout = this.$store.state.checkout
        let amount = checkout.applyCredit ? checkout.potentialCredit : 0
        if( checkout.applyCredit && checkout.orderTotal - checkout.potentialCredit >= 100){
          this.updateCreditAmount(amount)
        } else if (checkout.applyCredit) {
          this.updateCreditAmount(checkout.orderTotal)
        } else {
          this.updateCreditAmount(amount)
        }
        let body = JSON.stringify(
          { order: { apply_credit: checkout.applyCredit } }
        )
        CartApi.changeOrder(body)
      }
    }
  }
}
</script>
